document.addEventListener("DOMContentLoaded", function () {

    const modal = document.getElementById("priceRequestModal");
    if (!modal) return;

    const closeBtn = modal.querySelector(".pr-close");

    // OPEN MODAL (jaisa pehle tha, waise hi rehne do)
    document.addEventListener("click", function (e) {
        const btn = e.target.closest(".price-on-request-btn, #trigger-enquiry");
        if (!btn) return;
        e.preventDefault();
        modal.classList.add("active");
        document.body.style.overflow = "hidden";
    });

    closeBtn.addEventListener("click", function () {
        modal.classList.remove("active");
        document.body.style.overflow = "";
    });

    modal.addEventListener("click", function (e) {
        if (e.target === modal) {
            modal.classList.remove("active");
            document.body.style.overflow = "";
        }
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            modal.classList.remove("active");
            document.body.style.overflow = "";
        }
    });

    // ✅ NAYA: agar URL me ?contact_posted=true hai, matlab submission successful ho chuki
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') === 'true') {
    modal.querySelector(".pr-modal-box").innerHTML = `
        <button class="pr-close success-close">&times;</button>

        <h2>Thank You! 🙏</h2>
        <p>Your request has been submitted successfully. Our luxury consultant will contact you shortly.</p>
    `;

    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    // GTM Event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "generate_lead",
        form_name: "request_price"
    });

    // URL clean
    params.delete("contact_posted");
    const cleanUrl =
        window.location.pathname +
        (params.toString() ? "?" + params.toString() : "") +
        window.location.hash;

    window.history.replaceState({}, "", cleanUrl);

    // Refresh Function
    const reloadPage = () => {
        window.location.href = cleanUrl;
    };

    // Cross Click
    modal.querySelector(".success-close").addEventListener("click", reloadPage);

    // Auto Refresh after 5 sec
    setTimeout(reloadPage, 5000);
}

    // ✅ SIMPLE SUBMIT (fetch hata diya — ab native submit hi hoga)
    const form = document.getElementById("PriceRequestForm");
    if (form) {
        form.addEventListener("submit", function () {
    const btn = form.querySelector(".request-submit");

    btn.disabled = true;
    btn.classList.add("loading");
    btn.innerHTML = `
        <span class="spinner"></span>
        Submitting...
    `;
});
    }
});